import React from "react";
import { useContext } from "react";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";

const PlayAgainButton = () => {

    const {handleTimer, resetTime} = useContext(MemoryTimerContext);
    const {handleShuffleCards, handleMemoryCompleted, setReadyToCheckCards} = useContext(MemoryLevelContext);
    const {handleShowCounter, updateCountDown} = useContext(MemoryCountDownContext);
    
    const playAgain = () => {
        setReadyToCheckCards(true);
        handleTimer(false);
        resetTime();
        updateCountDown(false);
        handleShowCounter(true);
        handleMemoryCompleted(false);
        handleShuffleCards();
    };

    return(
        <span className="button-container">
            <button className="button" onClick={() => playAgain()}>
                <span className="label button--label">Spela igen</span>
                <span className="button--icon-container">
                    <i className="arrow arrow--right arrow--button" aria-hidden="true"></i>
                </span>
            </button>
        </span>
    );

};

export default PlayAgainButton;